// frontend/src/components/TermsAgreement.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/TermsAgreement.css';

const TermsAgreement = ({ 
  isChecked, 
  onChange, 
  checkboxId = "terms-agreement",
  className = "",
  disabled = false 
}) => {
  return (
    <div className={`terms-agreement-container ${className}`}>
      <input
        type="checkbox"
        id={checkboxId}
        className="terms-agreement-checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={disabled}
      />
      <label htmlFor={checkboxId} className="terms-agreement-label">
        I agree to the{' '}
        <Link 
          to="/terms-of-service" 
          className="terms-agreement-link"
        >
          Terms of Service
        </Link>
        {' '}and{' '}
        <Link 
          to="/privacy-policy" 
          className="terms-agreement-link"
        >
          Privacy Policy
        </Link>
        .
      </label>
    </div>
  );
};

export default TermsAgreement;
